import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import './i18n';
import App from './App';

const container = document.getElementById('root');

const getBasename = () => {
  return window.location.pathname.startsWith('/app/') || window.location.pathname === '/app' ? '/app' : '/';
};

const rootElement = (
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter basename={getBasename()} future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <App />
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);

if (container.hasChildNodes()) {
  hydrateRoot(container, rootElement);
} else {
  createRoot(container).render(rootElement);
}
